module.exports = "/work-site/img/progress.2a9c786c.png";